import React from 'react';
import WName from '../WName';
import PL from './ProblemLink';
import AL from '../angles/AngleLink';
import QL from '../faq/QuestionLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, Qual} from '../common';

// Funds funds funds funds DO YOU HAVE THE FUNDS?????????///
export const funds = {
  name: "funds",
  prelude: <span>
    But do <AL>YOU</AL><sup>™</sup> have the <i>funds</i> for that?
  </span>,
  header: <span>
    Funds are a sympton of 𐒐𐒖𐒑𐒖 𐒂𐒝𐒈𐒘𐒒 (misalignment).
  </span>,
  outside: <span>
    Only on the <NW>BOLT</NW> would <QL name="tm">One<sup>™</sup></QL> need <PL name="might makes right">might-makes-right</PL> (<i><NW>money</NW></i>) to <NW word="forca">forçar</NW> os <QL name="others">Outros</QL><sup>™</sup> (force Others<sup>™</sup>) to do things <i>your way</i>.
  </span>,
  preview: <div className="problem-preview">
    <p><PL>Hierarchy</PL>. Domination: the <PL name="rule them all">AshEejitDurbatulûk</PL><sup>™</sup>. Zero-sum game on whose rules we <i><LRL name="game">cannot agree</LRL></i> – so it’s not-managed by <PL>Mamma</PL> <LRL>Reactivity</LRL>.</p>
    <p>Do you have the funds = Do you have the <i>clout</i> to <i>demand</i> BlindObedience<sup>™</sup> from Others<sup>™</sup>? Not for any reason that might <NW word="toosin">𐒂𐒝𐒈𐒘𐒒</NW> (toosin: align) with <NW word="haklal">הכלל</NW> (haklal: the pig picture). Because in the <NW>BOLT</NW>, might makes right and we’re just all literal <PL>Nazis</PL> in steadfast <PL>denial</PL> about it, cf Adam Smith’s ‘<PL name="metaphysics">invisible hand</PL>’.</p>
    <p>That ‘invisible hand’ in the <NW>BOLT</NW> of ‘capitaliam’ is <i><QL>consciousness</QL></i> – literally <NW>God</NW> – trying for <NW word="overcome">Ganzesystemüberwindung</NW> in the <AL>Hell</AL> we’ve created together by <i>refusing to work together</i>, cf. <NW>entropy</NW>, ‘<PL>evil</PL>’, and the ‘<AL name="notnew.p.arendt">banality</AL>’ of it. We worship the Devil and call it ‘<PL>privacy</PL>’.</p>
  </div>,
//  text: <div className="problem-text">
//  </div>,
};
